<template>
  <el-container>
    <el-header class="header">
      <Header></Header>
    </el-header>
  
    <el-container>
      <el-main class="section">
        <router-view></router-view>
      <el-footer class="footer">
        <Footer></Footer>
      </el-footer>
      </el-main>
    </el-container>
  </el-container>
</template>

<script type="text/ecmascript-6">
  import Header from '@commonControl/header'
  import Footer from '@commonControl/footer'
  import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
  export default {
    data() {
      return {}
    },
    components: {
      Header,
      Footer,
      provinceAndCityData
    }
  }
</script>

<style lang="less" scoped>
  .header {
    width: 100%;
    height: 148px!important;
    overflow: hidden;
  }
  /deep/.section {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 0;
  }
  .footer {
    width: 100%;
    height: 220px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/main.vue